/**
 * Email widgets (2026-10-27) — the on-screen preview of a company design. Mirrors the server's
 * wrap (services/emailWidget.service.js) for DISPLAY ONLY: the server sanitises the body and
 * builds the mail that is actually sent. Shown in a sandboxed iframe, never injected into the page.
 */

const CONTENT_SLOT = /\{\{\s*content\s*\}\}/g;
const SUBJECT_SLOT = /\{\{\s*email_subject\s*\}\}/g;
// {{greeting}} — the opening line the sender may change at send time (2026-10-28).
const GREETING_SLOT = /\{\{\s*greeting\s*\}\}/g;
export const DEFAULT_GREETING = "Hi {{customer_name}},";
export const hasGreetingSlot = (html) => /\{\{\s*greeting\s*\}\}/.test(String(html ?? ""));

export const SAMPLE_BODY = "<p>Your message appears here.</p>";
export const SAMPLE_SUBJECT = "Your subject appears here";

export const countContentSlots = (html) => (String(html ?? "").match(CONTENT_SLOT) || []).length;

const escapeHtml = (s) => String(s ?? "")
  .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
  .replace(/"/g, "&quot;").replace(/'/g, "&#39;");

// The company's own details read the same in every mail, so the preview shows them for real:
// the logo the navbar cached from the company profile, the name, the year. Placeholders about
// the recipient ({{customer_name}} …) stay — they differ per person.
const readLogo = () => {
  try { return localStorage.getItem("logo_url") || ""; } catch { return ""; }
};
const companyDetails = () => ({ company_name: "Entermark", current_year: String(new Date().getFullYear()), company_logo: readLogo() });

const withCompanyDetails = (html) => {
  const details = companyDetails();
  return html.replace(/\{\{\s*(company_name|current_year|company_logo)\s*\}\}/g, (m, key) => details[key] || m);
};

// A note line (the editor's "Note" button) shows as the design's highlight box, as the server sends it.
const withNoteBoxes = (html) => html.replace(/<blockquote>([\s\S]*?)<\/blockquote>/g, (_m, inner) =>
  '<blockquote style="margin:20px 0 16px;padding:14px 18px;border-left:3px solid #5b2fd6;background:#f7f4ff;font-family:Arial,sans-serif;font-size:14px;color:#3d4566;line-height:1.7">'
  + inner.replace(/<(b|strong)>/g, '<$1 style="color:#5b2fd6">') + "</blockquote>");

/** The design with the subject in its heading and the body in its slot. Function replacers keep "$&" literal. */
export const previewWidget = (widgetHtml, bodyHtml, subject, greeting) =>
  withCompanyDetails(String(widgetHtml ?? ""))
    .replace(GREETING_SLOT, () => escapeHtml(typeof greeting === "string" && greeting.trim() ? greeting.trim() : DEFAULT_GREETING))
    .replace(SUBJECT_SLOT, () => escapeHtml(subject))
    .replace(CONTENT_SLOT, () => withNoteBoxes(String(bodyHtml ?? "")));
